var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
const basePath = '/Registrations';
const prepareCreateData = (_a) => {
    var body = __rest(_a, []);
    return JSON.stringify(body);
};
export const registrationsDataProvider = context => {
    return {
        create: async (_a) => {
            var { data } = _a, body = __rest(_a, ["data"]);
            const url = `${context.apiUrl}${basePath}`;
            const { json } = await context.fetchJson(url, {
                credentials: 'include',
                method: 'POST',
                body: prepareCreateData(body),
            });
            return {
                data: Object.assign({}, json),
            };
        },
    };
};
//# sourceMappingURL=registrations.js.map